import { createSlice } from '@reduxjs/toolkit'
import { keyBy } from '../../../../helpers/common'
import { register } from '../../../../helpers/reducerRegistry'
import { valByKeyWithDot } from '../../../../helpers/value'
import { ALL_STATUS, REQUEST_TYPE_FILTER } from '../constants'
import {
  getDetailRequestConfirmation,
  getSNPNewTransactionPreview,
  getSubscriptionAndPackageOrdersById,
  getSubscriptionAndPackageOrdersPaged,
  getSubscriptionAndPackageOrdersTypes,
  postCancelRequestOrder,
} from './thunk'

export const slice = createSlice({
  name: 'userManagement/packageSubscriptionManagement',
  initialState: {
    isLoading: false,
    loadingRequestConfirmation: false,
    packageSubscription: {
      ids: [],
      dataById: {},
      origData: [],
    },
    filter: {
      page: 1,
      pageSize: 10,
      from: undefined,
      to: undefined,
      totalRecords: 0,
      requestType: REQUEST_TYPE_FILTER[0],
      type: ALL_STATUS,
      requestStatus: ALL_STATUS,
      paymentStatus: ALL_STATUS,
    },
    typeList: [],
    detailRequestInfoAll: {},
    isLoadingDetailRequestTable: true,
    detailRequestTable: {
      ids: [],
      dataById: {},
      origData: [],
    },
    isCancelSuccessfully: false,
    dataPreview: {},
  },
  reducers: {
    changeFilter: (state, { payload = {} }) => {
      state.filter = { ...state.filter, ...payload }
      if (!Object.keys(payload)?.includes('page')) {
        state.filter.page = 1
      }
    },
    resetDataPreview: (state) => {
      state.dataPreview = {}
    },
  },
  extraReducers: (builder) => {
    //get SubscriptionAndPackageOrders Paged
    builder.addCase(getSubscriptionAndPackageOrdersPaged.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(
      getSubscriptionAndPackageOrdersPaged.fulfilled,
      (state, action) => {
        state.isLoading = false

        const payloadData = action.payload
          ? action.payload.data.map((item, index) => ({
              ...item,
              order: index + 1,
            }))
          : []
        state.packageSubscription.origData = payloadData
        state.packageSubscription.ids = payloadData.map((item) => item.id)
        state.packageSubscription.dataById = keyBy(payloadData, 'id')

        state.filter.totalRecords = action.payload.totalRecords
        state.filter.page = action.payload.page
        state.filter.pageSize = action.payload.pageSize
      },
    )
    builder.addCase(
      getSubscriptionAndPackageOrdersPaged.rejected,
      (state, action) => {
        state.isLoading = action.payload.loading
      },
    )
    //get SubscriptionAndPackage Orders Types
    builder.addCase(
      getSubscriptionAndPackageOrdersTypes.fulfilled,
      (state, action) => {
        state.typeList = action.payload
      },
    )

    //get SubscriptionAndPackage Orders ById
    builder.addCase(getSubscriptionAndPackageOrdersById.pending, (state) => {
      state.isLoadingDetailRequestTable = true
    })
    builder.addCase(
      getSubscriptionAndPackageOrdersById.fulfilled,
      (state, action) => {
        state.isLoadingDetailRequestTable = false
        state.detailRequestInfoAll = action.payload

        const detailsTableData = action.payload.details
          ? action.payload.details.map((item, index) => ({
              ...item,
              order: index + 1,
              name: item.fiinGateReportTypeName,
            }))
          : []
        state.detailRequestTable.origData = detailsTableData
        state.detailRequestTable.ids = detailsTableData.map((item) => item.id)
        state.detailRequestTable.dataById = keyBy(detailsTableData, 'id')
        state.isCancelSuccessfully = false
      },
    )
    builder.addCase(
      getSubscriptionAndPackageOrdersById.rejected,
      (state, action) => {
        state.isLoadingDetailRequestTable = action.payload.loading
      },
    )
    builder.addCase(postCancelRequestOrder.fulfilled, (state) => {
      state.isCancelSuccessfully = true
    })
    builder.addCase(getSNPNewTransactionPreview.fulfilled, (state, action) => {
      state.dataPreview = action.payload
    })
    // getDetailRequestConfirmation
    builder.addCase(getDetailRequestConfirmation.pending, (state, action) => {
      state.loadingRequestConfirmation = true
    })
    builder.addCase(getDetailRequestConfirmation.fulfilled, (state, action) => {
      state.loadingRequestConfirmation = false
    })
    builder.addCase(getDetailRequestConfirmation.rejected, (state, action) => {
      state.loadingRequestConfirmation = false
    })
  },
})

export const selectLoadingSubscriptionAndPackageOrders = (state) =>
  state[slice.name].isLoading
export const selectSubscriptionAndPackageOrdersDataById =
  (id, attr) => (state) =>
    valByKeyWithDot(state[slice.name].packageSubscription.dataById[id], attr)
export const selectSubscriptionAndPackageOrdersIds = (state) =>
  state[slice.name].packageSubscription.ids
export const selectSubscriptionAndPackageOrdersData = (state) =>
  state[slice.name].packageSubscription.origData

export const selectFilterByKey = (key) => (state) =>
  state[slice.name].filter[key]
export const selectFilter = (state) => state[slice.name].filter

export const selectSubscriptionAndPackageTypes = (state) =>
  state[slice.name].typeList

export const selectDetailRequestInfoAll = (state) =>
  state[slice.name].detailRequestInfoAll

export const selectLoadingDetailRequestTable = (state) =>
  state[slice.name].isLoadingDetailRequestTable
export const selectDetailRequestTableById = (id, attr) => (state) =>
  valByKeyWithDot(state[slice.name].detailRequestTable.dataById[id], attr)
export const selectDetailRequestTableIds = (state) =>
  state[slice.name].detailRequestTable.ids
export const selectDetailRequestTableData = (state) =>
  state[slice.name].detailRequestTable.origData
export const selectIsCancelSuccessfully = (state) =>
  state[slice.name].isCancelSuccessfully
export const selectSNPNewTransactionPreview = (state) =>
  state[slice.name].dataPreview
export const selectLoadingRequestConfirmation = (state) =>
  state[slice.name].loadingRequestConfirmation

export const { changeFilter, resetDataPreview } = slice.actions

register(slice.name, slice.reducer)
